<template>
    
</template>

<script>
    export default {
        name: "costAccountingColumnsList"
    }
</script>

<style scoped>

</style>
